(function () {
  Flint.file('mframework/views/loader.js', function (require) {
    Flint.staticStyles('Loader', {
      '$': '#_flintapp .ViewLoader'
    }, {
      '$': {
        opacity: 0.5,
        width: 50,
        alignItems: 'center',
        justifyContent: 'center'
      }
    });
    Flint.view('Loader', function (view, on, $) {
      ;view.render(function () {
        return view.el(['img', 1], { src: '/images/loader.gif' });
      });
    });
  })
})();
//# sourceMappingURL=loader.js.map
